import { api_GET, api_POST, api_PUT, api_DELETE } from "../api/_axios.js";

const diasnaouteis_api =
{
    getAll: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`DiaNaoUtil`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`DiaNaoUtil/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`DiaNaoUtil`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_PUT(`DiaNaoUtil`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    delete: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_DELETE(`DiaNaoUtil`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default diasnaouteis_api
